<template>
  <div>
    <el-dialog title="截图询价报价浮动" :visible.sync="dialogVisible" width="800px">
      <div style="padding: 10px; background-color: #f5f5f5; color: #d9534f;">
        <div style="color:#fd9b46;">
          设置浮动后，用户在该api对应的店铺询价时，给用户的报价会在平台原始报价基础上，加上报价浮动的金额（向上取整）。
        </div>
        注意：设置报价浮动，不影响出票成功率和订单结算成本计算。不管报价浮动是提高还是降低，订单的结算成本还是按平台的原始报价进行计算。
      </div>

      <el-form :model="form" :rules="rules" ref="form" label-width="160px" style="margin-top: 20px;">
        <el-form-item label="报价浮动：市场价x" prop="discountFloat">
          <div style="display: flex;width: 100%;">
<!--            <div style="width: 70px;">市场价x</div>-->
<!--            <el-form-item label="" >市场价x</el-form-item>-->
            <el-input v-model="form.discountFloat" placeholder="请输入-8~8之间" suffix-icon="el-icon-percent" style="width: 200px;">
<!--              <template #append>%</template>-->
            </el-input>
            <div style="width: 20px;margin-left: 10px;">%</div>
          </div>
        </el-form-item>
      </el-form>

      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="loading" type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateDiscountFloat } from '@/api/open.js'
export default {
  data() {
    return {
      dialogVisible: false,
      loading:false,
      row:{},
      form: {
        discountFloat: "",
      },
      rules: {
        discountFloat: [
          { required: true, message: "请输入报价浮动值", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!/^(-?\d+(\.\d{1})?)$/.test(value)) {
                callback(new Error("请输入数字，支持一位小数"));
              } else if (value < -8 || value > 8) {
                callback(new Error("请输入-8到8之间的值"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
        ],
      },
    };
  },
  watch:{
    dialogVisible(val){
      if(!val){
        this.resetForm();
      }
    }
  },
  methods: {
    init(row) {
      this.row = row
      this.dialogVisible = true;
      this.form = {
        discountFloat: row.inquiry_discount_float ? row.inquiry_discount_float : '0',
      };
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          updateDiscountFloat({
            id:this.row.id,
            discountFloat: this.form.discountFloat,
          }).then(res => {
            console.log(res,'res====')
            if(res.code === 200){
              this.$message.success(res.message);
              this.dialogVisible = false;
              this.$emit('refresh');
            }else{
              this.$message.error(res.message);
            }
          }).catch(err => {
            this.$message.error(err.message);
          })
            .finally(() => {
            this.loading = false;
          });
        } else {
          // this.$message.error("请检查输入的值是否正确");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields(); // 清空表单内容和校验状态
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right; /* 将按钮对齐到右侧 */
  padding-right: 10px; /* 根据需要调整右侧边距 */
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/manage/modal/discountFloatPop.vue